module.exports = __webpack_public_path__ + "static/img/profile-icon06.7419bdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/profile-icon06.png
// module id = 2954
// module chunks = 1